<template>
  <v-card>
    <GenericListTable
      :parentID="this.parentID"
      :title="`Assets`"
      :headers="[
        { text: 'ID', value: 'id' },
        { text: 'Asset Id', value: 'co_assetid' },
        { text: 'Description', value: 'co_description' },
        { text: 'Asset State', value: 'assetstate' },
        { text: 'Asset Note', value: 'assetnote' },
        { text: 'Group code', value: 'co_groupcode' },
        { text: 'Device Name', value: 'devicename' },
        { text: 'Location ID', value: 'co_locationid' },
      ]"
      :url="`/manifest/assetinfo`"
      :apiResponseField="`assetinfolist`"
      :onClickRoute="`AssetSingle`"
      :onClickParams="getOnClickParams"
      :editable="true"
      :saveUrl="`manifest/assetinfo/bulk?ids_to_update=`"
    >
    </GenericListTable>
  </v-card>
</template>

<script>
import GenericListTable from '@/components/Common/GenericListTable'
export default {
  name: 'AssetListTable',
  components: { GenericListTable },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      search: '',
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Asset Id', value: 'co_assetid' },
        { text: 'Description', value: 'co_description' },
        { text: 'Asset State', value: 'assetstate' },
        { text: 'Asset Note', value: 'assetnote' },
        { text: 'Group code', value: 'co_groupcode' },
        { text: 'Device Name', value: 'devicename' },
        { text: 'Location ID', value: 'co_locationid' }
      ],
      assets: []
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.co_assetid,
        assets: this.assets
      }
    }
  }
}
</script>
